export default function HeroButtons() {
  function scrollToTabs() {
    const el = document.getElementById("tabs-section");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  return (
    <div className="mx-auto mt-8 w-full max-w-2xl">
      <div className="grid grid-cols-2 gap-3 sm:gap-4">
        <a
          href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7435533137314721792"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex flex-col items-center justify-center rounded-2xl border border-[var(--dash-border)] bg-[var(--dash-surface)] px-3 py-7 text-center transition-all duration-300 hover:-translate-y-1.5 hover:scale-[1.02] hover:border-[#0077b5] hover:bg-[var(--dash-surface-hover)] hover:shadow-[0_0_28px_rgba(0,119,181,0.45)] sm:px-5 sm:py-9"
        >
          <i
            className="fab fa-linkedin mb-4 text-3xl text-[#0077b5] transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_14px_rgba(0,119,181,0.85)] sm:mb-5 sm:text-4xl"
            aria-hidden
          />
          <span className="mb-2 text-[9px] font-bold uppercase tracking-[0.12em] text-[#58a6ff] sm:text-[10px] sm:tracking-[0.15em]">
            LinkedIn Newsletter
          </span>
          <span className="text-sm font-bold leading-snug text-[var(--dash-text-strong)] sm:text-base md:text-lg">
            Never Miss an Update
          </span>
        </a>

        <a
          href="https://www.youtube.com/@tg-tools-hub"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex flex-col items-center justify-center rounded-2xl border border-[var(--dash-border)] bg-[var(--dash-surface)] px-3 py-7 text-center transition-all duration-300 hover:-translate-y-1.5 hover:scale-[1.02] hover:border-[#ff0000] hover:bg-[var(--dash-surface-hover)] hover:shadow-[0_0_28px_rgba(255,0,0,0.4)] sm:px-5 sm:py-9"
        >
          <i
            className="fab fa-youtube mb-4 text-3xl text-[#ff0000] transition-all duration-300 group-hover:scale-110 group-hover:drop-shadow-[0_0_14px_rgba(255,0,0,0.85)] sm:mb-5 sm:text-4xl"
            aria-hidden
          />
          <span className="mb-2 text-[9px] font-bold uppercase tracking-[0.12em] text-[#ff6b6b] sm:text-[10px] sm:tracking-[0.15em]">
            YouTube Channel
          </span>
          <span className="text-sm font-bold leading-snug text-[var(--dash-text-strong)] sm:text-base md:text-lg">
            Subscribe &amp; Grow Faster
          </span>
        </a>
      </div>

      <button
        type="button"
        onClick={scrollToTabs}
        className="mt-3 flex w-full items-center justify-center gap-2 rounded-full bg-[#229ED9] py-3.5 text-base font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:scale-[1.01] hover:bg-[#00a2f3] hover:shadow-[0_0_24px_rgba(34,158,217,0.45)] sm:mt-4 sm:py-4 sm:text-lg"
      >
        Get Started
        <span aria-hidden>→</span>
      </button>
    </div>
  );
}
